import { RouterProvider } from "react-router-dom";
import { ThemeProvider } from "@mui/material";
import {AuthProvider} from "./context/auth/AuthContext.tsx";
import { ColorModeContext, useMode } from "./theme";
import router from "./appRouter";
import {Theme} from "@mui/material/styles";
import {Amplify} from "aws-amplify";
import config from "./aws-exports";
const stage = import.meta.env.VITE_API_STAGE;

Amplify.configure({
    ...config,
    // @ts-ignore
    aws_cloud_logic_custom: [
        {
            name: "KMGCloud",
            endpoint: `https://vgkesm6t1j.execute-api.eu-central-1.amazonaws.com/${stage}`,
            region: "eu-central-1"
        }
    ]
});

const App = () => {
    const [theme, colorMode] = useMode() as [Theme, { toggleColorMode: () => void }];
    return (
        <ColorModeContext.Provider value={colorMode}>
            <ThemeProvider theme={theme}>
                <AuthProvider>
                    <RouterProvider router={router} />
                </AuthProvider>
            </ThemeProvider>
        </ColorModeContext.Provider>
    );
};

export default App;
